import { render, staticRenderFns } from "./result-chart.vue?vue&type=template&id=0d485118&scoped=true&"
import script from "./result-chart.vue?vue&type=script&lang=js&"
export * from "./result-chart.vue?vue&type=script&lang=js&"
import style0 from "./result-chart.vue?vue&type=style&index=0&id=0d485118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d485118",
  null
  
)

export default component.exports